import { GraphQLQueryClass } from "@bsm/component";
import { TDescriptor } from "@bsm/graphql";

export class CurrenciesQuery implements GraphQLQueryClass<Array<TDescriptor>, TResponse> {
    public queryKey: string = "App.Bsm.Invoice.CurrenciesQuery";

    public gql: string = CURRENCY_LIST_GQL
    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): Array<TDescriptor> {
        return data.descriptors.data;
    }
}

export type TResponse = {
    descriptors: {
        data: Array<TDescriptor>
    };
};

export const CURRENCY_LIST_GQL = `
        query CurrenciesQuery {
            descriptors (filter: { data: { tp: "CURRENCY" } }){
                data { 
                    id
                    value
                    translationKey
                }
            }
        }
    `;